// import { decryptedData } from 'src/views/Access'
import axios from 'axios'
import { LocalURL, LoginURL, NEWURL, URLKpostLogin, AssetsURL, MeetingURL } from './URL'

// const getToken = async () => {
//   let token = null
//   try {
//     const encryptedToken = await localStorage.getItem('USERTOKEN')
//     if (encryptedToken) {
//       token = decryptedData(encryptedToken)
//     }
//   } catch (error) {
//     console.error(error)
//   }
//   return token
// }


export async function getCountrylist() {
  try {
    const response = await fetch(`${URLKpostLogin}/common/countries`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        // Authorization: token,
      },
      // body: JSON.stringify(body),
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 201) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function LoginKpostAPI(body) {
  try {
    const response = await fetch(`${URLKpostLogin}/common/getCompanyDetails`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function FetchKpostId(body) {
  try {
    const response = await fetch(`${URLKpostLogin}/signupLogin/fetchUserDetails`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function LoginKpost(body) {
  try {
    const response = await fetch(`${URLKpostLogin}/signupLogin/userLogin`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export const postalPincode = async (body) => {
  console.log(body, 'testsce')
  try {
    const response = await fetch(`${URLKpostLogin}/common/postalPinCode`, {
      method: `post`,
      headers: {
        'Content-Type': 'application/json',
        // Authorization: token,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (response.status === 401 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (e) {
    throw e
  }
}

// Forget Password

export async function ForgetPasswordSentOTP(body) {
  try {
    const response = await fetch(`${URLKpostLogin}/common/forgotPasswordOTPOrSentKpostIDSms`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 401 || response.status === 400 || response.status === 404) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function ForgetPasswordOTPVerify(body) {
  try {
    const response = await fetch(`${URLKpostLogin}/common/validateOTP`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 401 || response.status === 400 || response.status === 404) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function ForgetPasswordUpdate(body) {
  try {
    const response = await fetch(`${URLKpostLogin}/common/forgotPasswordUpdate`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 401 || response.status === 400 || response.status === 404) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}
// Forget Password

export async function PostTYpe(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(
      `${LocalURL}/types/save`,
      {
        method: `POST`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function getAlltypes(levelID, page = 1, limit = 10) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(
      `${LocalURL}/types/get-by-level/${levelID}?page=${page}&limit=${limit}`,
      {
        method: `GET`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function getFilterBytypesID(ID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/types/get/${ID}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function UpdateByType(body, ID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/type/update/${ID}`, {
      method: `PATCH`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function DeleteByType(ID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/type/delete/${ID}`, {
      method: `DELETE`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function PostWord(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(
      `${LocalURL}/words/create`,
      {
        method: `POST`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function getAllWords(page, limit) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/words/getAll?page=${page}&limit=${limit}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}


export async function UpdateByWord(body, ID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/word/update/${ID}`, {
      method: `PATCH`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function CreatingDictionary(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(
      `${LocalURL}/dictionary-bulk/create`,
      {
        method: `POST`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      },
    )
    if (response.status === 200 || response.status === 201 || response.status === 207) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function getAllFilterByDictionaryID(parentTypeID, typeId, wordId, pageId, limit) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/dictionary/get?parentTypeId=${parentTypeID}&typeId=${typeId}&wordId=${wordId}&page=${pageId}&limit=${limit}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function getAllByDictionary(page, limit) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/dictionary/getAll?page=${page}&limit=${limit}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function LoginAPI(body) {
  try {
    const response = await fetch(
      `${LoginURL}/user/login`,
      {
        method: `POST`,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function FetcUserData(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/user/fetch-data`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export async function LoginByKPOSTID(body) {
  try {
    const response = await fetch(`${LoginURL}/user/login`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500 || response.status === 401 || response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function CreteTiers(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(
      `${LocalURL}/tiers/create`,
      {
        method: `POST`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function getFilterByTiers(parentTypeID, typeId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/tiers/get-by-type/?parentTypeId=${parentTypeID}&typeId=${typeId}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function UpdateByTier(body, ID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/tier/update/${ID}`, {
      method: `PATCH`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function GetAllTiersList(page, limit) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/tiers/getAll?page=${page}&limit=${limit}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}


export async function DeleteTiers(id) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/tier/delete/${id}`, {
      method: `DELETE`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function CreateVariables(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(
      `${LocalURL}/variables/create`,
      {
        method: `POST`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function GetVariables(id) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(
      `${LocalURL}/variable/get-by-tier/${id}`,
      {
        method: `GET`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        }
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function DeleteVariable(id) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/variable/delete/${id}`, {
      method: `DELETE`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function DeleteWord(ID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/word/delete/${ID}`, {
      method: `DELETE`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function UpdateVariable(body, ID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/variable/update/${ID}`, {
      method: `PATCH`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function UpdateDictionary(body, ID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/dictionary/update/${ID}`, {
      method: `PATCH`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function getallAgeGroup() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/age-groups/getAll`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}


export async function CreateTirerVariableMapping(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(
      `${LocalURL}/tier-variable/mappings/add`,
      {
        method: `POST`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function gettiervariablemappingbyFilter(wordID, parentTypeID, typeID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/tier-variable-mapping/filter?wordId=${wordID}&parentTypeId=${parentTypeID}&typeId=${typeID}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function gettiervariablemapping() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/tier-variable-mapping/filter`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function CreateEnCylopedia(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/encylopedia-content/create`,
      {
        method: `POST`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}


export async function getallencyclopediadatas(page, limit) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/encylopedia-contents/getAll?page=${page}&limit=${limit}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}


export async function getallencyclopediaFilterIdBydata(parentTypeID, typeID, wordID, page, limit) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/encyclopedia-content/getByFilter?parentTypeId=${parentTypeID}&typeId=${typeID}&wordId=${wordID}&page=${page}&limit=${limit}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}


export async function UpdateEncylopediaCreation(body, ID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/encyclopedia-content/update/${ID}`, {
      method: `PATCH`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function UploadWordsExcel(file) {
  try {
    const token = JSON.parse(localStorage.getItem("accessToken"));

    const formData = new FormData();
    formData.append("file", file); // 👈 key must be "file"

    const response = await fetch(
      `${LocalURL}/words/upload-excel`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          // ❌ Content-Type set panna vendam for FormData
        },
        body: formData,
      }
    );

    if (response.status === 200 || response.status === 201) {
      return await response.json();
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json();
    } else if (response.status === 403) {
      return await response.json();
    } else {
      const errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (error) {
    console.error(error);
  }
}

export async function getAllWordsByDefault() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/words/get-by-filter`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function getAllWordsByFilterByID(id) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/word/${id}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}


export async function getAllWordsBySearchQuery(pagenumber, searchname, limit) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/words/get-by-filter?page=${pagenumber}&search=${searchname}&limit=${limit}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function gettypesbylevel(levelID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/type/get/${levelID}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function gettypesbyparentlevel(levelID, page, parentTypeID, searchvalue) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/type/get/${levelID}?page=${page}&parentTypeId=${parentTypeID}&search=${searchvalue}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function getuserType() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/user-role/get`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}


export async function CreateRegister(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/user/create`, {
      method: `POST`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body)
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function getRegisterDetails() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/user/getAll`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function getCountryList() {
  try {
    // const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/countries/getAll`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()

      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error("API Error:", error?.response || error.message);
  }
}

export async function getallencyclopediaContentByID(contentID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/encylopedia-content/${contentID}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function DeleteDictionaryByWords(id) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/dictionary/delete/${id}`, {
      method: `DELETE`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function DeleteEncylopediaCreations(id) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/encyclopedia-content/delete/${id}`, {
      method: `DELETE`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function BlockByUser(userID, block) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/user/block-status/${userID}?block=${block}`, {
      method: `PATCH`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      // body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function UpdateCreateGregistration(body, ID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LoginURL}/user/profile-update/${ID}`, {
      method: `PATCH`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

// export async function getexcelforsampledownload(id) {
//   try {
//     const token = JSON.parse(localStorage.getItem('accessToken'))
//     const response = await fetch(`${LocalForExcelURL}/dictionary/bulk-upload/template/${id}`, {
//       method: `GET`,
//       headers: {
//         'Content-Type': 'application/json',
//         Authorization: `Bearer ${token}`,
//       },
//     })
//     if (response.status === 200 || response.status === 201) {
//       return await response.json()
//     } else if (
//       response.status === 401 ||
//       response.status === 400 ||
//       response.status === 404 ||
//       response.status === 500
//     ) {
//       return await response.json()
//     } else if (response.status === 403) {
//       return await response.json()
//     } else {
//       var errorResponse = await response.json()
//       throw new Error(errorResponse.error)
//     }
//   } catch (error) { }
// }

export async function getexcelforsampledownload(id) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'));

    const response = await fetch(
      `${LocalURL}/dictionary/bulk-upload/template?module=${id}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          // ❌ do NOT use application/json when downloading files
        },
      }
    );

    if (response.ok) {
      // ✅ read as blob
      const blob = await response.blob();

      // ✅ create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "template.xlsx"); // file name
      document.body.appendChild(link);
      link.click();

      // cleanup
      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } else {
      // if API returns error JSON
      const errorResponse = await response.json();
      return errorResponse;
    }
  } catch (error) {
    console.error("Excel download failed:", error);
  }
}


export async function getexcelforsampledownloadforEncylopedia(id) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'));

    const response = await fetch(
      `${LocalURL}/encyclopedia/bulk-upload/template?module=${id}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          // ❌ do NOT use application/json when downloading files
        },
      }
    );

    if (response.ok) {
      // ✅ read as blob
      const blob = await response.blob();

      // ✅ create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "template.xlsx"); // file name
      document.body.appendChild(link);
      link.click();

      // cleanup
      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } else {
      // if API returns error JSON
      const errorResponse = await response.json();
      return errorResponse;
    }
  } catch (error) {
    console.error("Excel download failed:", error);
  }
}

export async function NewMethodEncylopediaUploadFile(file, subTypeId, ageGroupId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch(`${LocalURL}/encyclopedia/bulk/upload/${subTypeId}/${ageGroupId}`, {
      method: `POST`,
      headers: {
        // 'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error(error);
  }
}

export async function getallencyclopediaupload() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/encyclopedia/uploads`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}


export async function UpdateUploadFileForEncyclopedia(ID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/encyclopedia/file-extract/retry/${ID}`, {
      method: `PUT`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function dictionaryFailedUploaddata(ID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/dictionary/fail-uploads/${ID}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function encyclopediaFailedUploaddata(ID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/encyclopedia/fail-uploads/${ID}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}


export async function getalldictionaryupload() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/dictionary/uploads`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function UpdateUploadFile(ID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/dictionary/file-extract/retry/${ID}`, {
      method: `PUT`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function NewMethodDictionaryUploadFile(file, id) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch(`${LocalURL}/dictionary/bulk/upload/${id}`, {
      method: `POST`,
      headers: {
        // 'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error(error);
  }
}

export async function PostCompany(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(
      `${NEWURL}/companies/add`,
      {
        method: `POST`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function UpdateCompany(body, ID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${NEWURL}/companies/update/${ID}`, {
      method: `PATCH`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function getallCompanies() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${NEWURL}/companies/getAll`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function PostCourse(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(
      `${NEWURL}/courses/add`,
      {
        method: `POST`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function getcourseByID(companyId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${NEWURL}/courses/get-by-company/${companyId}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function PostCourseYears(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(
      `${NEWURL}/course-years/add`,
      {
        method: `POST`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function UpdateCourses(body, ID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${NEWURL}/courses/update/${ID}`, {
      method: `PATCH`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function getallCourses() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${NEWURL}/courses/getAll`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function getallYearsofStudy() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${NEWURL}/course-years/getAll`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function getFilterYearsofCourseID(courseId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${NEWURL}/course-years/by-course/${courseId}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function UpdateYearofStudy(body, ID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${NEWURL}/course-years/update/${ID}`, {
      method: `PATCH`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function PostProducts(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(
      `${NEWURL}/products/add`,
      {
        method: `POST`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function AssetsUploadFile(formData) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))

    const response = await fetch(`${NEWURL}/assets/stream/image-list`, {
      method: `POST`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    console.error(error);
  }
}

export async function getallProductList() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${NEWURL}/products/getAll`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}


export async function getCompanybyProductiD(productID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${NEWURL}/products/get-by-company/${productID}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}


export async function PostFeature(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${NEWURL}/product-features/add`,
      {
        method: `POST`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function getallFeatureList() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${NEWURL}/product-features/getAll`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function PostBilling(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(
      `${NEWURL}/billing-cycles/add`,
      {
        method: `POST`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function getallBillingList() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${NEWURL}/billing-cycles/getAll`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function getallFeaturelistByID(id) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${NEWURL}/product-features/get-by-product/${id}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function getallBillinglistByID(id) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${NEWURL}/billing-cycles/get/${id}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}


export async function getcompanyfilterbyID(id) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${NEWURL}/course-years/by-company/${id}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}


export async function getProductcompanyfilterbyID(id) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${NEWURL}/product-features/get-by-company/${id}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function UpdateBilling(body, ID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${NEWURL}/billing-cycles/update/${ID}`, {
      method: `PATCH`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}


export async function UpdateFeature(body, ID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${NEWURL}/product-features/update/${ID}`, {
      method: `PATCH`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function UpdatetheProduct(body, ID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${NEWURL}/products/update/${ID}`, {
      method: `PATCH`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function DeleteProductImage(ID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${NEWURL}/assets/stream/image-list/${ID}`, {
      method: `DELETE`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function getBannerProductID(id) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${NEWURL}/products/banners/${id}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function getdictionaryField(moduleid) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/dictionary/fields/${moduleid}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function PostDictionaryMapping(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(
      `${LocalURL}/dictionary/field-type/mapping/add`,
      {
        method: `POST`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function getdictionaryFieldMappingType(typeId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/dictionary/field-type/mapping/${typeId}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export async function UpdateMandatoryFields(body, ID) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/dictionary/field-type/mapping/update/${ID}`, {
      method: `PATCH`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function getencylopediaContentbyIds(wordID, typeId, ageGroupId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/encyclopedia/ai-content/get?word=${wordID}&typeId=${typeId}&ageGroupId=${ageGroupId}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200) {
      return await response.json()
    } else if (response.status === 404 || response.status === 400 || response.status === 500) {
      return await response.json()
    } else if (response.status === 401 || response.status === 403) {
      return { status: '403' }
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) {
    throw new Error(error)
  }
}

export const updloadImageAssetsFile = async (
  file,
  appId,
  title
) => {
  const token = JSON.parse(localStorage.getItem('accessToken'))
  const data = new FormData();
  data.append("image", file);
  const TitleName = title !== "" && title !== "undefined" && title !== undefined && title !== "null" && title !== null ? title : "";
  console.log("TitleName", TitleName);
  try {
    const response = await axios.post(
      `${AssetsURL}/assets/upload/image${TitleName !== "" ? `?filename=${TitleName}` : ""}`,
      data,
      {
        headers: {
          //   "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "x-app-id": appId,
          "x-process-request": "standard_upload"
        },
      },
      {}
    );
    console.log(response);
    if (response.status === 200) {
      return await response.data;
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.data;
    } else {
      var errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (e) {
    console.log(e);
    // ✅ axios puts error response here
    if (e.response) {
      // server responded with error status
      console.log(e.response);

      return e.response.data;
    } else if (e.request) {
      // no response received
      console.log("No response from server");
      throw new Error("No response from server");
    } else {
      // something else went wrong
      console.log(e.message);
      throw new Error(e.message);
    }
  }
};

// upload audio
export const updloadAudioAssetsFile = async (
  file,
  appId,
  title
) => {
  const token = JSON.parse(localStorage.getItem('accessToken'))
  const data = new FormData();
  data.append("audio", file);
  const TitleName = title !== "" && title !== "undefined" && title !== undefined && title !== "null" && title !== null ? title : "";
  try {
    const response = await axios.post(
      `${AssetsURL}/assets/stream/audio${TitleName !== "" ? `?filename=${TitleName}` : ""}`,
      data,
      {
        headers: {
          //   "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "x-app-id": appId,
          "x-process-request": "standard_upload"
        },
      },
      {}
    );
    console.log(response);
    if (response.status === 200) {
      return await response.data;
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.data;
    } else {
      var errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (e) {
    console.log(e);
    // ✅ axios puts error response here
    if (e.response) {
      // server responded with error status
      console.log(e.response);

      return e.response.data;
    } else if (e.request) {
      // no response received
      console.log("No response from server");
      throw new Error("No response from server");
    } else {
      // something else went wrong
      console.log(e.message);
      throw new Error(e.message);
    }
  }
};

// upload video
export const updloadVideoAssetsFile = async (
  file,
  appId,
  title
) => {
  const token = JSON.parse(localStorage.getItem('accessToken'));
  const data = new FormData();
  data.append("video", file);
  const TitleName = title !== "" && title !== "undefined" && title !== undefined && title !== "null" && title !== null ? title : "";
  try {
    const response = await axios.post(
      `${AssetsURL}/assets/stream/video${TitleName !== "" ? `?filename=${TitleName}` : ""}`,
      data,
      {
        headers: {
          //   "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "x-app-id": appId,
          "x-process-request": "standard_upload"
        },
      },
      {}
    );
    console.log(response);
    if (response.status === 200) {
      return await response.data;
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.data;
    } else {
      var errorResponse = await response.json();
      throw new Error(errorResponse.error);
    }
  } catch (e) {
    console.log(e);
    // ✅ axios puts error response here
    if (e.response) {
      // server responded with error status
      console.log(e.response);

      return e.response.data;
    } else if (e.request) {
      // no response received
      console.log("No response from server");
      throw new Error("No response from server");
    } else {
      // something else went wrong
      console.log(e.message);
      throw new Error(e.message);
    }
  }
};

export async function PostMeetingSchedule(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(
      `${LocalURL}/meeting`,
      {
        method: `POST`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function getspecilaitydata(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(
      `https://journalsapiview.katbook.com/v1/filter/speciality/all`,
      {
        method: `GET`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function GetMeetingSchedule() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(
      `${MeetingURL}/meeting`,
      {
        method: `GET`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        }
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}


export async function PostUploadingMeedingFiles(file, meetingId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch(
      `${MeetingURL}/meeting/${meetingId}/file`,
      {
        method: `POST`,
        headers: {
          // 'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function GetUpladedByMeetingId(meetingID,selectedSession) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(
      `${MeetingURL}/meeting/${meetingID}/files/?sessionId=${selectedSession}`,
      {
        method: `GET`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        }
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}


export async function DeletebyUploadedMeeting(meetingId, fileId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${MeetingURL}/meeting/${meetingId}/file/${fileId}`, {
      method: `DELETE`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function PostUploadingMeetings(body, meetingId) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(
      `${MeetingURL}/meeting/${meetingId}/file-details`,
      {
        method: `POST`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}


export async function GetDashboardDataCounts() {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(
      `${MeetingURL}/dashboard`,
      {
        method: `GET`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        }
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function DeleteEncylopediaContent(id) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/encyclopedia/ai-content/${id}`, {
      method: `DELETE`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function postActivityHeartbeat(body) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(
      `${LocalURL}/activity/heartbeat`,
      {
        method: `POST`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      },
    )
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 409 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}

export async function getUserDataDetails(fromdate, todate) {
  try {
    const token = JSON.parse(localStorage.getItem('accessToken'))
    const response = await fetch(`${LocalURL}/activity/users?from=${fromdate}&to=${todate}`, {
      method: `GET`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    if (response.status === 200 || response.status === 201) {
      return await response.json()
    } else if (
      response.status === 401 ||
      response.status === 400 ||
      response.status === 404 ||
      response.status === 500
    ) {
      return await response.json()
    } else if (response.status === 403) {
      return await response.json()
    } else {
      var errorResponse = await response.json()
      throw new Error(errorResponse.error)
    }
  } catch (error) { }
}
